<template>
  <div class="upgrade-notice-mask">
    <div class="upgrade-notice-card">
      <img class="upgrade-notice-bg" src="@/assets/assets.jpg" alt="系统服务升级公告" />
      <div class="upgrade-notice-content">
        为进一步提升服务效率，宝就业平台管理系统将于{{ startTime }}至{{ endTime }}停止服务，进行系统升级，给您带来的不便，敬请谅解！
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpgradeNotice',
  props: {
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      jumpUrl: 'https://bs-baojiuye.1haozc.com'
    }
  }
}
</script>

<style lang="scss" scoped>
.upgrade-notice-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.upgrade-notice-card {
  position: relative;
  width: #{'min(640px, 92vw, calc(90vh * 4 / 3))'};
}

.upgrade-notice-bg {
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
  user-select: none;
}

.upgrade-notice-content {
  position: absolute;
  left: 10%;
  right: 10%;
  top: 58%;
  color: #3a4a5c;
  font-size: #{'clamp(13px, 2.2vw, 16px)'};
  line-height: 1.8;
  text-align: center;
  word-break: break-all;
  pointer-events: none;
  user-select: none;
}

.upgrade-notice-link {
  position: absolute;
  left: 8%;
  right: 8%;
  bottom: 8.5%;
  height: 11.5%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #eaf4ff;
  color: #5a6478;
  font-size: #{'clamp(12px, 2.4vw, 16px)'};
  line-height: 1;
  text-decoration: none;
  cursor: pointer;
  user-select: text;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);
}

.upgrade-notice-link:hover {
  background: #dceeff;
}

.upgrade-notice-url {
  color: #1677ff;
  margin: 0 4px;
  font-weight: 500;
}

@media (max-width: 768px) {
  .upgrade-notice-content {
    top: 56%;
    left: 8%;
    right: 8%;
    font-size: 13px;
    line-height: 1.7;
  }

  .upgrade-notice-link {
    font-size: 13px;
    left: 6%;
    right: 6%;
  }
}
</style>
